import { BaseModel } from './BaseModel';
import UserEnrollment from './UserEnrollment';
export class AvailableTime extends BaseModel {
  static get entity() {
    return 'available-times';
  }

  static get fk() {
    return ['available_time_id', 'available_time'];
  }

  static fields() {
    return {
      id: this.uid(),
      learning_unit: this.attr(null),
      start_at: this.attr(null),
      end_at: this.attr(null),
      // last_submission: this.attr(null),
      last_enrollment: this.attr(null),
      number_of_learners: this.attr(null),
      max_learners: this.attr(null),
      created_at: this.attr(null),
      updated_At: this.attr(null),
      delete_at: this.attr(null),
      user_enrollments: this.hasMany(UserEnrollment, AvailableTime.fk[1])
    };
  }

  static apiConfig = {
    actions: {
      fetchById(id) {
        return this.get(`/available-times/${id}`);
      },

      updateAvailableTime(id, body) {
        return this.put(`/available-times/${id}`, body);
      },

      createAvailableTime(body) {
        return this.post(`/available-times`, body);
      },

      deleteAvailableTime(id) {
        return this.delete(`/available-times/${id}`);
      }
    }
  };
}

export default AvailableTime;
